<div class="app-layout d-flex flex-column min-vh-100">
    <!-- Header -->
    <app-header></app-header>

    <!-- Main Content -->
    <main class="main flex-grow-1 overflow-auto">
        <router-outlet></router-outlet>
    </main>

    <!-- Footer -->
    <app-footer></app-footer>
</div>